import { render } from "./submit.vue?vue&type=template&id=c98a2028&scoped=true"
import script from "./submit.vue?vue&type=script&lang=js"
export * from "./submit.vue?vue&type=script&lang=js"

import "./submit.vue?vue&type=style&index=0&id=c98a2028&scoped=true&lang=css"

import exportComponent from "D:\\Users\\User\\Documents\\_PROJECTS\\VUE.JS\\tulmash\\web_widgets\\calc_feeder\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98a2028"]])

export default __exports__